import styled from 'styled-components';

export const Card = styled.li<{ columns: number }>`
  grid-column: 1 / span ${(props) => props.columns};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--gray-90);
  border-radius: 8px;

  @media (max-width: 640px) {
    min-height: auto;
  }
`;

export const Title = styled.h3`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 32px;
  line-height: 38.4px;
  font-weight: 700;
  letter-spacing: -0.4px;
`;

export const DetailsButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 20px 12px 24px;
  background-color: #00f99d;
  border-radius: 300px;
  color: #000;
  margin-right: 16px;

  span {
    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
    margin-right: 8px;
  }

  path {
    fill: black;
    max-width: 14px;
  }

  @media (max-width: 360px) {
    margin-right: unset;
  }
`;

export const ContentWrapper = styled.div<{ backgroundUrl: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 48px;
  height: 100%;
  background: linear-gradient(to left, transparent 0%, black 100%),
    url(${(props) => props.backgroundUrl});
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 240px;
  border-radius: 8px 8px 0 0;
  gap: 16px;

  @media (max-width: 640px) {
    gap: 24px;
    padding: 32px;
  }
`;

export const HighlightTagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const HighlightEssayButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: 360px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const TagWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    display: block;
    font-size: 12px;
    line-height: 24px;
    color: var(--white);
    background-color: var(--gray-02);
    padding: 0 8px;
    border-radius: 4px;
  }
`;

export const HighlightText = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  margin: 0 0.5em;
`;

export const DownloadAnchor = styled.a`
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    margin-right: 8px;
  }

  span {
    color: #fff;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: -0.6px;
    text-decoration: underline;
  }

  @media (max-width: 360px) {
    margin-top: 16px;
  }
`;
